import { EVENT_BUS } from "@/model/event-bus";
import { store } from "@/model/store";
import { getCurrentSceneName } from '@/scenes';

const MAX_HP = 15;
class Game {
    beats = 4
    song = {}
    // game-notation, game-2d, game-3d?
    mode = 'game-notation'
    // stop mode
    practiceMode = false;
    practiceModeStops = false;
    practiceModeTempoPercent = 100;
    audio = undefined;
    preMs = 145
    postMs = 145
    totalNotesMissed = 0;
    hitPoints = MAX_HP
    maxHitPoints = MAX_HP
    currentBeatNumber = 0
    lastBeatNumber = 0
    totalNotesHit = 0;
    noteHits = []
    _bpm = 120
    _isPlaying = false;
    _notes = [];
    comboStreak = 0;
    maxCombo = 0;

    reset() {
        this._bpm = 120;
        this.beats = 4;
        this.song = {};
        this.noteHits = [];
        this.mode = 'game-notation'
        this._isPlaying = false;
        this.audio = undefined;
        this.preMs = 130
        this.postMs = 130
        this._notes = [];
        this.totalNotesHit = 0;
        this.totalNotesMissed = 0;
        this.maxHitPoints = MAX_HP;
        this.hitPoints = this.maxHitPoints;
        this.currentBeatNumber = 0
        this.lastBeatNumber = 0
        this.comboStreak = 0;
        this.maxCombo = 0;
    }

    set bpm(bpm) {
        if (typeof bpm === 'string') {
            this._bpm = parseInt(bpm);
        } else {
            this._bpm = bpm;
        }
    }

    get bpm() {
        return this._bpm;
    }

    set notes(notes) {
        this._notes = notes.filter(note => !note.rest && !!note.pitch)
    }

    get settings() {
        return store.settings;
    }

    get isPlaying() {
        return this._isPlaying;
    }

    set isPlaying(value) {
        this._isPlaying = value;
    }

    constructor() {
        EVENT_BUS.on('MIDI_noteOn', ({ pianoNote }) => {
            this.onInput(pianoNote, true);
        });
        EVENT_BUS.on('MIDI_noteOff', ({ pianoNote }) => {
            this.onInput(pianoNote, false);
        });

    }

    get beatIntervalSeconds() {
        return 1 * (60 / this.bpm);
    }

    get countInTime() {
        return this.beatIntervalSeconds * this.beats;
    }

    getFittingNotes(hitTime) {
        return this._notes
            .filter(note => !note.played)
            .filter(
                ({ timeSeconds, durationSeconds }) => {
                    return hitTime >= timeSeconds - this.preMs / 1000 &&
                        hitTime < timeSeconds + durationSeconds + this.postMs / 1000
                });
    }

    onInput(pianoNote, noteOn) {
        const isGameScene = getCurrentSceneName().includes('game-');
        if (!isGameScene) {
            // We are not on GAME screen
            return;
        }

        if (noteOn) {
            // get current time 
            const hitTime = this.audio.currentTimeOffsetted;

            const fittingNotes = this.getFittingNotes(hitTime);

            const noteHit = fittingNotes.find(note => {
                return note.pianoNote === pianoNote;
            });

            if (noteHit) {
                noteHit.played = true;
                if (this.hitPoints < this.maxHitPoints) {
                    this.hitPoints += 0.5;
                }
                noteHit.grade = this.gradeNoteHit(noteHit, hitTime);
                EVENT_BUS.emit('NOTE_HIT', noteHit);
                this.comboStreak++;
                this.noteHits.push(noteHit);
                console.debug(`note hit ${hitTime} ${JSON.stringify(noteHit)}`)
                this.totalNotesHit++;

                if (this.practiceMode && this.practiceModeStops) {
                    const remainingNotes = this.getFittingNotes(hitTime);
                    if (remainingNotes.length > 0) {
                        console.debug(remainingNotes.map(n => n.pianoNote).join(', ') + ' remaining')
                    } else {
                        EVENT_BUS.emit('NOTE_STOP_MODE_RESUME');
                        return;
                    }
                }
            } else {
                console.debug(`${pianoNote} was pressed, ${fittingNotes.map(n => n.pianoNote).join(',')} were found`)
                if (this.practiceMode && this.practiceModeStops && fittingNotes.length === 0) {
                    EVENT_BUS.emit('NOTE_STOP_MODE_RESUME')
                }
            }
        }

    }

    gradeNoteHit(noteHit, hitTime) {
        const delta = Math.abs(noteHit.timeSeconds - hitTime) * 1000;
        if (delta <= 50) {
            return 'Perfect';
        } else if (delta <= 100) {
            return 'Great';
        } else if (delta <= 117) {
            return 'Good'
        } else if (delta <= 133) {
            return 'Bad';
        } else {
            return (noteHit.timeSeconds < hitTime) ? 'Late' : 'Early';
        }
    }
    update() {
        let hadMiss = false; // one miss per update
        const currentTime = this.audio.currentTimeOffsetted;
        this.currentBeatNumber = Math.trunc(this.audio.currentTimeOffsetted / (this.bpm / 60 / this.beats));
        if (this.currentBeatNumber > this.lastBeatNumber) {
            EVENT_BUS.emit('GAME_BEAT');
        }

        if (this.practiceMode && this.practiceModeStops && this.isPlaying) {
            this._notes.forEach((note) => {
                if (!note.played &&
                    currentTime > note.timeSeconds) {
                    EVENT_BUS.emit('NOTE_STOP_MODE_PAUSE', note);
                }
            });
        } else {
            this._notes.forEach((note) => {
                if (!note.played &&
                    currentTime > note.timeSeconds + this.postMs / 1000) {
                    note.played = true;
                    note.missed = true;
                    EVENT_BUS.emit('NOTE_MISS', note);
                    if (this.comboStreak > 0) {
                        this.maxCombo = Math.max(this.comboStreak, this.maxCombo);
                        EVENT_BUS.emit('COMBO_BREAK', this.comboStreak);
                        this.comboStreak = 0;
                    }
                    this.totalNotesMissed++;
                    if (!hadMiss) {
                        hadMiss = true;
                        this.hitPoints--;
                    }
                }
            });

        }

        if (this.hitPoints <= 0 && !this.settings.godMode) {
            EVENT_BUS.emit('GAME_FAIL');
        }
        this.lastBeatNumber = this.currentBeatNumber;
    }

}

const game = new Game();
export default game;